import * as z from 'zod';

export const QueryTipSettingsRequest = z.object({
  query: z
    .object({
      filter: z
        .object({
          _id: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          locationId: z
            .object({
              $eq: z.any(),
              $exists: z.boolean(),
              $gt: z.any(),
              $gte: z.any(),
              $hasAll: z.array(z.any()),
              $hasSome: z.array(z.any()),
              $in: z.array(z.any()),
              $lt: z.any(),
              $lte: z.any(),
              $ne: z.any(),
              $nin: z.array(z.any()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          paymentTerminalId: z
            .object({
              $eq: z.any(),
              $exists: z.boolean(),
              $gt: z.any(),
              $gte: z.any(),
              $hasAll: z.array(z.any()),
              $hasSome: z.array(z.any()),
              $in: z.array(z.any()),
              $lt: z.any(),
              $lte: z.any(),
              $ne: z.any(),
              $nin: z.array(z.any()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          default: z
            .object({
              $eq: z.boolean(),
              $exists: z.boolean(),
              $gt: z.boolean(),
              $gte: z.boolean(),
              $hasAll: z.array(z.boolean()),
              $hasSome: z.array(z.boolean()),
              $in: z.array(z.boolean()),
              $lt: z.boolean(),
              $lte: z.boolean(),
              $ne: z.boolean(),
              $nin: z.array(z.boolean()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          allowCustomerTip: z
            .object({
              $eq: z.boolean(),
              $exists: z.boolean(),
              $gt: z.boolean(),
              $gte: z.boolean(),
              $hasAll: z.array(z.boolean()),
              $hasSome: z.array(z.boolean()),
              $in: z.array(z.boolean()),
              $lt: z.boolean(),
              $lte: z.boolean(),
              $ne: z.boolean(),
              $nin: z.array(z.boolean()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          allowBusinessTipAtPayment: z
            .object({
              $eq: z.boolean(),
              $exists: z.boolean(),
              $gt: z.boolean(),
              $gte: z.boolean(),
              $hasAll: z.array(z.boolean()),
              $hasSome: z.array(z.boolean()),
              $in: z.array(z.boolean()),
              $lt: z.boolean(),
              $lte: z.boolean(),
              $ne: z.boolean(),
              $nin: z.array(z.boolean()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          allowEditDistribution: z
            .object({
              $eq: z.boolean(),
              $exists: z.boolean(),
              $gt: z.boolean(),
              $gte: z.boolean(),
              $hasAll: z.array(z.boolean()),
              $hasSome: z.array(z.boolean()),
              $in: z.array(z.boolean()),
              $lt: z.boolean(),
              $lte: z.boolean(),
              $ne: z.boolean(),
              $nin: z.array(z.boolean()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          allowCustomAmount: z
            .object({
              $eq: z.boolean(),
              $exists: z.boolean(),
              $gt: z.boolean(),
              $gte: z.boolean(),
              $hasAll: z.array(z.boolean()),
              $hasSome: z.array(z.boolean()),
              $in: z.array(z.boolean()),
              $lt: z.boolean(),
              $lte: z.boolean(),
              $ne: z.boolean(),
              $nin: z.array(z.boolean()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          tipType: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          $and: z.array(z.any()).optional(),
          $or: z.array(z.any()).optional(),
          $not: z.any().optional(),
        })
        .strict()
        .optional(),
      sort: z
        .array(
          z.object({
            fieldName: z
              .enum([
                '_id',
                'locationId',
                'paymentTerminalId',
                'default',
                'allowCustomerTip',
                'allowBusinessTipAtPayment',
                'allowEditDistribution',
                'allowCustomAmount',
                'tipType',
              ])
              .optional(),
            order: z.enum(['ASC', 'DESC']).optional(),
          })
        )
        .optional(),
    })
    .catchall(z.any())
    .describe('WQL expression'),
});
export const QueryTipSettingsResponse = z.object({
  tipSettings: z
    .array(
      z.intersection(
        z.object({
          _id: z
            .string()
            .describe('ID of the tip settings.')
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            )
            .optional()
            .nullable(),
          tipType: z
            .enum(['UNKNOWN_TIP_TYPE', 'PERCENTAGE', 'AMOUNT'])
            .describe('Tip type.')
            .optional(),
          presets: z
            .array(
              z.object({
                value: z
                  .number()
                  .describe(
                    "Value of the preset tip choice that's displayed to customers in the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\nFor example, `5`, `10`, and `15` percent or `1`, `3`, and `5` USD.\n\nMin: `0`"
                  )
                  .min(0)
                  .optional()
                  .nullable(),
                default: z
                  .boolean()
                  .describe(
                    "Whether this tip choice value is the default preset that's highlighted automatically in the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\n\nDefault: `false`"
                  )
                  .optional()
                  .nullable(),
              })
            )
            .min(1)
            .max(3)
            .optional(),
          allowCustomerTip: z
            .boolean()
            .describe(
              'Whether customers are allowed to tip during the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\n\nDefault: `true`'
            )
            .optional()
            .nullable(),
          allowBusinessTipAtPayment: z
            .boolean()
            .describe(
              'Whether the Wix users are given the option to add a tip during the\npayment collection flow in their dashboard.\n\nDefault: `true`'
            )
            .optional()
            .nullable(),
          allowCustomAmount: z
            .boolean()
            .describe(
              "Whether customers can enter a custom tip amount. If set to `false`, customers\ncan only select a tip value from the available `presets` and can't enter a\ncustom amount.\n\nDefault: `true`"
            )
            .optional()
            .nullable(),
          allowEditDistribution: z
            .boolean()
            .describe(
              "Whether Wix users are allowed to edit tip distributions. If set to\n`false`, Wix users can't edit distributions after they were created.\n\nDefault: `true`"
            )
            .optional()
            .nullable(),
          staffDistributionMethod: z
            .enum(['UNKNOWN_SPLIT_METHOD', 'EQUAL', 'PROPORTIONAL'])
            .describe(
              'How the tip is distributed among staff.\n\nSupported values:\n`UNKNOWN_SPLIT_METHOD`: There is no information about the staff distribution method.\n`EQUAL`: The tip is distributed equally among all staff.\n`PROPORTIONAL`: The tip is distributed proportionally among staff.'
            )
            .optional(),
          revision: z
            .string()
            .regex(/^-?\d+$/, 'Must be a valid Int64 string')
            .describe(
              'Revision number, which increments by 1 each time `tipSettings` object is\nupdated. To prevent conflicting changes, the current revision must be passed\nwhen updating `tipSettings`. Ignored when creating a `tipSettings` object.'
            )
            .optional()
            .nullable(),
          _createdDate: z
            .date()
            .describe(
              'Date and time the tip settings were created in\n`YYYY-MM-DDThh:mm:ss.sssZ` format.'
            )
            .optional()
            .nullable(),
          _updatedDate: z
            .date()
            .describe(
              'Date and time the tip settings were last updated in\n`YYYY-MM-DDThh:mm:ss.sssZ` format.'
            )
            .optional()
            .nullable(),
          default: z
            .boolean()
            .describe(
              "Whether these are the default tip settings.\n\nWix Tips automatically creates the default settings during\nthe app's installation. You can't delete these default settings\nbut you can update them. Wix Tips uses the default settings\nto calculate tips, unless you specify other settings."
            )
            .optional()
            .nullable(),
          appId: z
            .string()
            .describe(
              'ID of the app that has created the settings. See the list of app IDs for\nWix business solutions ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/apps-created-by-wix) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/apps-created-by-wix)).'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            )
            .optional()
            .nullable(),
          extendedFields: z
            .object({
              namespaces: z
                .record(z.string(), z.record(z.string(), z.any()))
                .describe(
                  'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
                )
                .optional(),
            })
            .describe(
              'Custom field data for the `tipSettings` object. Extended fields must be\nconfigured in the app dashboard before they can be accessed with API calls.'
            )
            .optional(),
        }),
        z.xor([
          z.object({
            locationId: z.never().optional(),
            paymentTerminalId: z.never().optional(),
            userId: z.never().optional(),
          }),
          z.object({
            paymentTerminalId: z.never().optional(),
            userId: z.never().optional(),
            locationId: z
              .string()
              .describe(
                'ID of the location ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/location-object))\nfor which the tip settings apply.'
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              ),
          }),
          z.object({
            locationId: z.never().optional(),
            userId: z.never().optional(),
            paymentTerminalId: z
              .string()
              .describe(
                "ID of the payment terminal for which the tip settings apply. Wix Tips doesn't\nvalidate the ID you provide.\n\nMax: 30 characters"
              )
              .max(30),
          }),
          z.object({
            locationId: z.never().optional(),
            paymentTerminalId: z.never().optional(),
            userId: z
              .string()
              .describe(
                'ID of the Wix user for whom the tip settings apply. For example, the site owner or a\n[site collaborator](https://support.wix.com/en/article/inviting-people-to-contribute-to-your-site).'
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              ),
          }),
        ])
      )
    )
    .optional(),
  pagingMetadata: z
    .object({
      count: z
        .number()
        .int()
        .describe('Number of items returned in the response.')
        .optional()
        .nullable(),
      offset: z
        .number()
        .int()
        .describe('Offset that was requested.')
        .optional()
        .nullable(),
      total: z
        .number()
        .int()
        .describe(
          'Total number of items that match the query. Returned if offset paging is used and the `tooManyToCount` flag is not set.'
        )
        .optional()
        .nullable(),
      tooManyToCount: z
        .boolean()
        .describe(
          'Flag that indicates the server failed to calculate the `total` field.'
        )
        .optional()
        .nullable(),
      cursors: z
        .object({
          next: z
            .string()
            .describe(
              'Cursor string pointing to the next page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
          prev: z
            .string()
            .describe(
              'Cursor pointing to the previous page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe(
          'Cursors to navigate through the result pages using `next` and `prev`. Returned if cursor paging is used.'
        )
        .optional(),
    })
    .describe('Metadata for the paged set of retrieved `tipSettings` objects.')
    .optional(),
});
export const UpdateTipSettingsRequest = z.object({
  tipSettings: z
    .intersection(
      z.object({
        _id: z
          .string()
          .describe('ID of the tip settings.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        tipType: z
          .enum(['UNKNOWN_TIP_TYPE', 'PERCENTAGE', 'AMOUNT'])
          .optional(),
        presets: z
          .array(
            z.object({
              value: z
                .number()
                .describe(
                  "Value of the preset tip choice that's displayed to customers in the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\nFor example, `5`, `10`, and `15` percent or `1`, `3`, and `5` USD.\n\nMin: `0`"
                )
                .min(0)
                .optional()
                .nullable(),
              default: z
                .boolean()
                .describe(
                  "Whether this tip choice value is the default preset that's highlighted automatically in the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\n\nDefault: `false`"
                )
                .optional()
                .nullable(),
            })
          )
          .min(1)
          .max(3)
          .optional(),
        allowCustomerTip: z
          .boolean()
          .describe(
            'Whether customers are allowed to tip during the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\n\nDefault: `true`'
          )
          .optional()
          .nullable(),
        allowBusinessTipAtPayment: z
          .boolean()
          .describe(
            'Whether the Wix users are given the option to add a tip during the\npayment collection flow in their dashboard.\n\nDefault: `true`'
          )
          .optional()
          .nullable(),
        allowCustomAmount: z
          .boolean()
          .describe(
            "Whether customers can enter a custom tip amount. If set to `false`, customers\ncan only select a tip value from the available `presets` and can't enter a\ncustom amount.\n\nDefault: `true`"
          )
          .optional()
          .nullable(),
        allowEditDistribution: z
          .boolean()
          .describe(
            "Whether Wix users are allowed to edit tip distributions. If set to\n`false`, Wix users can't edit distributions after they were created.\n\nDefault: `true`"
          )
          .optional()
          .nullable(),
        staffDistributionMethod: z
          .enum(['UNKNOWN_SPLIT_METHOD', 'EQUAL', 'PROPORTIONAL'])
          .optional(),
        revision: z
          .string()
          .regex(/^-?\d+$/, 'Must be a valid Int64 string')
          .describe(
            'Revision number, which increments by 1 each time `tipSettings` object is\nupdated. To prevent conflicting changes, the current revision must be passed\nwhen updating `tipSettings`. Ignored when creating a `tipSettings` object.'
          )
          .optional()
          .nullable(),
        _createdDate: z
          .date()
          .describe(
            'Date and time the tip settings were created in\n`YYYY-MM-DDThh:mm:ss.sssZ` format.'
          )
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe(
            'Date and time the tip settings were last updated in\n`YYYY-MM-DDThh:mm:ss.sssZ` format.'
          )
          .optional()
          .nullable(),
        default: z
          .boolean()
          .describe(
            "Whether these are the default tip settings.\n\nWix Tips automatically creates the default settings during\nthe app's installation. You can't delete these default settings\nbut you can update them. Wix Tips uses the default settings\nto calculate tips, unless you specify other settings."
          )
          .optional()
          .nullable(),
        appId: z
          .string()
          .describe(
            'ID of the app that has created the settings. See the list of app IDs for\nWix business solutions ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/apps-created-by-wix) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/apps-created-by-wix)).'
          )
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        extendedFields: z
          .object({
            namespaces: z
              .record(z.string(), z.record(z.string(), z.any()))
              .describe(
                'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
              )
              .optional(),
          })
          .describe(
            'Custom field data for the `tipSettings` object. Extended fields must be\nconfigured in the app dashboard before they can be accessed with API calls.'
          )
          .optional(),
      }),
      z.xor([
        z.object({
          locationId: z.never().optional(),
          paymentTerminalId: z.never().optional(),
          userId: z.never().optional(),
        }),
        z.object({
          paymentTerminalId: z.never().optional(),
          userId: z.never().optional(),
          locationId: z
            .string()
            .describe(
              'ID of the location ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/location-object))\nfor which the tip settings apply.'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            ),
        }),
        z.object({
          locationId: z.never().optional(),
          userId: z.never().optional(),
          paymentTerminalId: z
            .string()
            .describe(
              "ID of the payment terminal for which the tip settings apply. Wix Tips doesn't\nvalidate the ID you provide.\n\nMax: 30 characters"
            )
            .max(30),
        }),
        z.object({
          locationId: z.never().optional(),
          paymentTerminalId: z.never().optional(),
          userId: z
            .string()
            .describe(
              'ID of the Wix user for whom the tip settings apply. For example, the site owner or a\n[site collaborator](https://support.wix.com/en/article/inviting-people-to-contribute-to-your-site).'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            ),
        }),
      ])
    )
    .describe('Tip settings to update.'),
});
export const UpdateTipSettingsResponse = z.intersection(
  z.object({
    _id: z
      .string()
      .describe('ID of the tip settings.')
      .regex(
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
        'Must be a valid GUID'
      )
      .optional()
      .nullable(),
    tipType: z
      .enum(['UNKNOWN_TIP_TYPE', 'PERCENTAGE', 'AMOUNT'])
      .describe('Tip type.')
      .optional(),
    presets: z
      .array(
        z.object({
          value: z
            .number()
            .describe(
              "Value of the preset tip choice that's displayed to customers in the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\nFor example, `5`, `10`, and `15` percent or `1`, `3`, and `5` USD.\n\nMin: `0`"
            )
            .min(0)
            .optional()
            .nullable(),
          default: z
            .boolean()
            .describe(
              "Whether this tip choice value is the default preset that's highlighted automatically in the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\n\nDefault: `false`"
            )
            .optional()
            .nullable(),
        })
      )
      .min(1)
      .max(3)
      .optional(),
    allowCustomerTip: z
      .boolean()
      .describe(
        'Whether customers are allowed to tip during the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\n\nDefault: `true`'
      )
      .optional()
      .nullable(),
    allowBusinessTipAtPayment: z
      .boolean()
      .describe(
        'Whether the Wix users are given the option to add a tip during the\npayment collection flow in their dashboard.\n\nDefault: `true`'
      )
      .optional()
      .nullable(),
    allowCustomAmount: z
      .boolean()
      .describe(
        "Whether customers can enter a custom tip amount. If set to `false`, customers\ncan only select a tip value from the available `presets` and can't enter a\ncustom amount.\n\nDefault: `true`"
      )
      .optional()
      .nullable(),
    allowEditDistribution: z
      .boolean()
      .describe(
        "Whether Wix users are allowed to edit tip distributions. If set to\n`false`, Wix users can't edit distributions after they were created.\n\nDefault: `true`"
      )
      .optional()
      .nullable(),
    staffDistributionMethod: z
      .enum(['UNKNOWN_SPLIT_METHOD', 'EQUAL', 'PROPORTIONAL'])
      .describe(
        'How the tip is distributed among staff.\n\nSupported values:\n`UNKNOWN_SPLIT_METHOD`: There is no information about the staff distribution method.\n`EQUAL`: The tip is distributed equally among all staff.\n`PROPORTIONAL`: The tip is distributed proportionally among staff.'
      )
      .optional(),
    revision: z
      .string()
      .regex(/^-?\d+$/, 'Must be a valid Int64 string')
      .describe(
        'Revision number, which increments by 1 each time `tipSettings` object is\nupdated. To prevent conflicting changes, the current revision must be passed\nwhen updating `tipSettings`. Ignored when creating a `tipSettings` object.'
      )
      .optional()
      .nullable(),
    _createdDate: z
      .date()
      .describe(
        'Date and time the tip settings were created in\n`YYYY-MM-DDThh:mm:ss.sssZ` format.'
      )
      .optional()
      .nullable(),
    _updatedDate: z
      .date()
      .describe(
        'Date and time the tip settings were last updated in\n`YYYY-MM-DDThh:mm:ss.sssZ` format.'
      )
      .optional()
      .nullable(),
    default: z
      .boolean()
      .describe(
        "Whether these are the default tip settings.\n\nWix Tips automatically creates the default settings during\nthe app's installation. You can't delete these default settings\nbut you can update them. Wix Tips uses the default settings\nto calculate tips, unless you specify other settings."
      )
      .optional()
      .nullable(),
    appId: z
      .string()
      .describe(
        'ID of the app that has created the settings. See the list of app IDs for\nWix business solutions ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/apps-created-by-wix) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/apps-created-by-wix)).'
      )
      .regex(
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
        'Must be a valid GUID'
      )
      .optional()
      .nullable(),
    extendedFields: z
      .object({
        namespaces: z
          .record(z.string(), z.record(z.string(), z.any()))
          .describe(
            'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
          )
          .optional(),
      })
      .describe(
        'Custom field data for the `tipSettings` object. Extended fields must be\nconfigured in the app dashboard before they can be accessed with API calls.'
      )
      .optional(),
  }),
  z.xor([
    z.object({
      locationId: z.never().optional(),
      paymentTerminalId: z.never().optional(),
      userId: z.never().optional(),
    }),
    z.object({
      paymentTerminalId: z.never().optional(),
      userId: z.never().optional(),
      locationId: z
        .string()
        .describe(
          'ID of the location ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/location-object))\nfor which the tip settings apply.'
        )
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        ),
    }),
    z.object({
      locationId: z.never().optional(),
      userId: z.never().optional(),
      paymentTerminalId: z
        .string()
        .describe(
          "ID of the payment terminal for which the tip settings apply. Wix Tips doesn't\nvalidate the ID you provide.\n\nMax: 30 characters"
        )
        .max(30),
    }),
    z.object({
      locationId: z.never().optional(),
      paymentTerminalId: z.never().optional(),
      userId: z
        .string()
        .describe(
          'ID of the Wix user for whom the tip settings apply. For example, the site owner or a\n[site collaborator](https://support.wix.com/en/article/inviting-people-to-contribute-to-your-site).'
        )
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        ),
    }),
  ])
);
export const CreateTipSettingsRequest = z.object({
  tipSettings: z
    .intersection(
      z.object({
        _id: z
          .string()
          .describe('ID of the tip settings.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        tipType: z
          .enum(['UNKNOWN_TIP_TYPE', 'PERCENTAGE', 'AMOUNT'])
          .optional(),
        presets: z
          .array(
            z.object({
              value: z
                .number()
                .describe(
                  "Value of the preset tip choice that's displayed to customers in the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\nFor example, `5`, `10`, and `15` percent or `1`, `3`, and `5` USD.\n\nMin: `0`"
                )
                .min(0)
                .optional()
                .nullable(),
              default: z
                .boolean()
                .describe(
                  "Whether this tip choice value is the default preset that's highlighted automatically in the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\n\nDefault: `false`"
                )
                .optional()
                .nullable(),
            })
          )
          .min(1)
          .max(3)
          .optional(),
        allowCustomerTip: z
          .boolean()
          .describe(
            'Whether customers are allowed to tip during the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\n\nDefault: `true`'
          )
          .optional()
          .nullable(),
        allowBusinessTipAtPayment: z
          .boolean()
          .describe(
            'Whether the Wix users are given the option to add a tip during the\npayment collection flow in their dashboard.\n\nDefault: `true`'
          )
          .optional()
          .nullable(),
        allowCustomAmount: z
          .boolean()
          .describe(
            "Whether customers can enter a custom tip amount. If set to `false`, customers\ncan only select a tip value from the available `presets` and can't enter a\ncustom amount.\n\nDefault: `true`"
          )
          .optional()
          .nullable(),
        allowEditDistribution: z
          .boolean()
          .describe(
            "Whether Wix users are allowed to edit tip distributions. If set to\n`false`, Wix users can't edit distributions after they were created.\n\nDefault: `true`"
          )
          .optional()
          .nullable(),
        staffDistributionMethod: z
          .enum(['UNKNOWN_SPLIT_METHOD', 'EQUAL', 'PROPORTIONAL'])
          .optional(),
        revision: z
          .string()
          .regex(/^-?\d+$/, 'Must be a valid Int64 string')
          .describe(
            'Revision number, which increments by 1 each time `tipSettings` object is\nupdated. To prevent conflicting changes, the current revision must be passed\nwhen updating `tipSettings`. Ignored when creating a `tipSettings` object.'
          )
          .optional()
          .nullable(),
        _createdDate: z
          .date()
          .describe(
            'Date and time the tip settings were created in\n`YYYY-MM-DDThh:mm:ss.sssZ` format.'
          )
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe(
            'Date and time the tip settings were last updated in\n`YYYY-MM-DDThh:mm:ss.sssZ` format.'
          )
          .optional()
          .nullable(),
        default: z
          .boolean()
          .describe(
            "Whether these are the default tip settings.\n\nWix Tips automatically creates the default settings during\nthe app's installation. You can't delete these default settings\nbut you can update them. Wix Tips uses the default settings\nto calculate tips, unless you specify other settings."
          )
          .optional()
          .nullable(),
        appId: z
          .string()
          .describe(
            'ID of the app that has created the settings. See the list of app IDs for\nWix business solutions ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/apps-created-by-wix) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/apps-created-by-wix)).'
          )
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        extendedFields: z
          .object({
            namespaces: z
              .record(z.string(), z.record(z.string(), z.any()))
              .describe(
                'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
              )
              .optional(),
          })
          .describe(
            'Custom field data for the `tipSettings` object. Extended fields must be\nconfigured in the app dashboard before they can be accessed with API calls.'
          )
          .optional(),
      }),
      z.xor([
        z.object({
          locationId: z.never().optional(),
          paymentTerminalId: z.never().optional(),
          userId: z.never().optional(),
        }),
        z.object({
          paymentTerminalId: z.never().optional(),
          userId: z.never().optional(),
          locationId: z
            .string()
            .describe(
              'ID of the location ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/location-object))\nfor which the tip settings apply.'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            ),
        }),
        z.object({
          locationId: z.never().optional(),
          userId: z.never().optional(),
          paymentTerminalId: z
            .string()
            .describe(
              "ID of the payment terminal for which the tip settings apply. Wix Tips doesn't\nvalidate the ID you provide.\n\nMax: 30 characters"
            )
            .max(30),
        }),
        z.object({
          locationId: z.never().optional(),
          paymentTerminalId: z.never().optional(),
          userId: z
            .string()
            .describe(
              'ID of the Wix user for whom the tip settings apply. For example, the site owner or a\n[site collaborator](https://support.wix.com/en/article/inviting-people-to-contribute-to-your-site).'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            ),
        }),
      ])
    )
    .describe('Tip settings to create.'),
});
export const CreateTipSettingsResponse = z.intersection(
  z.object({
    _id: z
      .string()
      .describe('ID of the tip settings.')
      .regex(
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
        'Must be a valid GUID'
      )
      .optional()
      .nullable(),
    tipType: z
      .enum(['UNKNOWN_TIP_TYPE', 'PERCENTAGE', 'AMOUNT'])
      .describe('Tip type.')
      .optional(),
    presets: z
      .array(
        z.object({
          value: z
            .number()
            .describe(
              "Value of the preset tip choice that's displayed to customers in the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\nFor example, `5`, `10`, and `15` percent or `1`, `3`, and `5` USD.\n\nMin: `0`"
            )
            .min(0)
            .optional()
            .nullable(),
          default: z
            .boolean()
            .describe(
              "Whether this tip choice value is the default preset that's highlighted automatically in the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\n\nDefault: `false`"
            )
            .optional()
            .nullable(),
        })
      )
      .min(1)
      .max(3)
      .optional(),
    allowCustomerTip: z
      .boolean()
      .describe(
        'Whether customers are allowed to tip during the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\n\nDefault: `true`'
      )
      .optional()
      .nullable(),
    allowBusinessTipAtPayment: z
      .boolean()
      .describe(
        'Whether the Wix users are given the option to add a tip during the\npayment collection flow in their dashboard.\n\nDefault: `true`'
      )
      .optional()
      .nullable(),
    allowCustomAmount: z
      .boolean()
      .describe(
        "Whether customers can enter a custom tip amount. If set to `false`, customers\ncan only select a tip value from the available `presets` and can't enter a\ncustom amount.\n\nDefault: `true`"
      )
      .optional()
      .nullable(),
    allowEditDistribution: z
      .boolean()
      .describe(
        "Whether Wix users are allowed to edit tip distributions. If set to\n`false`, Wix users can't edit distributions after they were created.\n\nDefault: `true`"
      )
      .optional()
      .nullable(),
    staffDistributionMethod: z
      .enum(['UNKNOWN_SPLIT_METHOD', 'EQUAL', 'PROPORTIONAL'])
      .describe(
        'How the tip is distributed among staff.\n\nSupported values:\n`UNKNOWN_SPLIT_METHOD`: There is no information about the staff distribution method.\n`EQUAL`: The tip is distributed equally among all staff.\n`PROPORTIONAL`: The tip is distributed proportionally among staff.'
      )
      .optional(),
    revision: z
      .string()
      .regex(/^-?\d+$/, 'Must be a valid Int64 string')
      .describe(
        'Revision number, which increments by 1 each time `tipSettings` object is\nupdated. To prevent conflicting changes, the current revision must be passed\nwhen updating `tipSettings`. Ignored when creating a `tipSettings` object.'
      )
      .optional()
      .nullable(),
    _createdDate: z
      .date()
      .describe(
        'Date and time the tip settings were created in\n`YYYY-MM-DDThh:mm:ss.sssZ` format.'
      )
      .optional()
      .nullable(),
    _updatedDate: z
      .date()
      .describe(
        'Date and time the tip settings were last updated in\n`YYYY-MM-DDThh:mm:ss.sssZ` format.'
      )
      .optional()
      .nullable(),
    default: z
      .boolean()
      .describe(
        "Whether these are the default tip settings.\n\nWix Tips automatically creates the default settings during\nthe app's installation. You can't delete these default settings\nbut you can update them. Wix Tips uses the default settings\nto calculate tips, unless you specify other settings."
      )
      .optional()
      .nullable(),
    appId: z
      .string()
      .describe(
        'ID of the app that has created the settings. See the list of app IDs for\nWix business solutions ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/apps-created-by-wix) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/apps-created-by-wix)).'
      )
      .regex(
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
        'Must be a valid GUID'
      )
      .optional()
      .nullable(),
    extendedFields: z
      .object({
        namespaces: z
          .record(z.string(), z.record(z.string(), z.any()))
          .describe(
            'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
          )
          .optional(),
      })
      .describe(
        'Custom field data for the `tipSettings` object. Extended fields must be\nconfigured in the app dashboard before they can be accessed with API calls.'
      )
      .optional(),
  }),
  z.xor([
    z.object({
      locationId: z.never().optional(),
      paymentTerminalId: z.never().optional(),
      userId: z.never().optional(),
    }),
    z.object({
      paymentTerminalId: z.never().optional(),
      userId: z.never().optional(),
      locationId: z
        .string()
        .describe(
          'ID of the location ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/location-object))\nfor which the tip settings apply.'
        )
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        ),
    }),
    z.object({
      locationId: z.never().optional(),
      userId: z.never().optional(),
      paymentTerminalId: z
        .string()
        .describe(
          "ID of the payment terminal for which the tip settings apply. Wix Tips doesn't\nvalidate the ID you provide.\n\nMax: 30 characters"
        )
        .max(30),
    }),
    z.object({
      locationId: z.never().optional(),
      paymentTerminalId: z.never().optional(),
      userId: z
        .string()
        .describe(
          'ID of the Wix user for whom the tip settings apply. For example, the site owner or a\n[site collaborator](https://support.wix.com/en/article/inviting-people-to-contribute-to-your-site).'
        )
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        ),
    }),
  ])
);
export const CreateDefaultTipSettingsRequest = z.object({
  tipSettings: z
    .intersection(
      z.object({
        _id: z
          .string()
          .describe('ID of the tip settings.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        tipType: z
          .enum(['UNKNOWN_TIP_TYPE', 'PERCENTAGE', 'AMOUNT'])
          .optional(),
        presets: z
          .array(
            z.object({
              value: z
                .number()
                .describe(
                  "Value of the preset tip choice that's displayed to customers in the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\nFor example, `5`, `10`, and `15` percent or `1`, `3`, and `5` USD.\n\nMin: `0`"
                )
                .min(0)
                .optional()
                .nullable(),
              default: z
                .boolean()
                .describe(
                  "Whether this tip choice value is the default preset that's highlighted automatically in the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\n\nDefault: `false`"
                )
                .optional()
                .nullable(),
            })
          )
          .min(1)
          .max(3)
          .optional(),
        allowCustomerTip: z
          .boolean()
          .describe(
            'Whether customers are allowed to tip during the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\n\nDefault: `true`'
          )
          .optional()
          .nullable(),
        allowBusinessTipAtPayment: z
          .boolean()
          .describe(
            'Whether the Wix users are given the option to add a tip during the\npayment collection flow in their dashboard.\n\nDefault: `true`'
          )
          .optional()
          .nullable(),
        allowCustomAmount: z
          .boolean()
          .describe(
            "Whether customers can enter a custom tip amount. If set to `false`, customers\ncan only select a tip value from the available `presets` and can't enter a\ncustom amount.\n\nDefault: `true`"
          )
          .optional()
          .nullable(),
        allowEditDistribution: z
          .boolean()
          .describe(
            "Whether Wix users are allowed to edit tip distributions. If set to\n`false`, Wix users can't edit distributions after they were created.\n\nDefault: `true`"
          )
          .optional()
          .nullable(),
        staffDistributionMethod: z
          .enum(['UNKNOWN_SPLIT_METHOD', 'EQUAL', 'PROPORTIONAL'])
          .optional(),
        revision: z
          .string()
          .regex(/^-?\d+$/, 'Must be a valid Int64 string')
          .describe(
            'Revision number, which increments by 1 each time `tipSettings` object is\nupdated. To prevent conflicting changes, the current revision must be passed\nwhen updating `tipSettings`. Ignored when creating a `tipSettings` object.'
          )
          .optional()
          .nullable(),
        _createdDate: z
          .date()
          .describe(
            'Date and time the tip settings were created in\n`YYYY-MM-DDThh:mm:ss.sssZ` format.'
          )
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe(
            'Date and time the tip settings were last updated in\n`YYYY-MM-DDThh:mm:ss.sssZ` format.'
          )
          .optional()
          .nullable(),
        default: z
          .boolean()
          .describe(
            "Whether these are the default tip settings.\n\nWix Tips automatically creates the default settings during\nthe app's installation. You can't delete these default settings\nbut you can update them. Wix Tips uses the default settings\nto calculate tips, unless you specify other settings."
          )
          .optional()
          .nullable(),
        appId: z
          .string()
          .describe(
            'ID of the app that has created the settings. See the list of app IDs for\nWix business solutions ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/apps-created-by-wix) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/apps-created-by-wix)).'
          )
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        extendedFields: z
          .object({
            namespaces: z
              .record(z.string(), z.record(z.string(), z.any()))
              .describe(
                'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
              )
              .optional(),
          })
          .describe(
            'Custom field data for the `tipSettings` object. Extended fields must be\nconfigured in the app dashboard before they can be accessed with API calls.'
          )
          .optional(),
      }),
      z.xor([
        z.object({
          locationId: z.never().optional(),
          paymentTerminalId: z.never().optional(),
          userId: z.never().optional(),
        }),
        z.object({
          paymentTerminalId: z.never().optional(),
          userId: z.never().optional(),
          locationId: z
            .string()
            .describe(
              'ID of the location ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/location-object))\nfor which the tip settings apply.'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            ),
        }),
        z.object({
          locationId: z.never().optional(),
          userId: z.never().optional(),
          paymentTerminalId: z
            .string()
            .describe(
              "ID of the payment terminal for which the tip settings apply. Wix Tips doesn't\nvalidate the ID you provide.\n\nMax: 30 characters"
            )
            .max(30),
        }),
        z.object({
          locationId: z.never().optional(),
          paymentTerminalId: z.never().optional(),
          userId: z
            .string()
            .describe(
              'ID of the Wix user for whom the tip settings apply. For example, the site owner or a\n[site collaborator](https://support.wix.com/en/article/inviting-people-to-contribute-to-your-site).'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            ),
        }),
      ])
    )
    .describe('Default tip settings to create.'),
});
export const CreateDefaultTipSettingsResponse = z.object({
  tipSettings: z
    .intersection(
      z.object({
        _id: z
          .string()
          .describe('ID of the tip settings.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        tipType: z
          .enum(['UNKNOWN_TIP_TYPE', 'PERCENTAGE', 'AMOUNT'])
          .describe('Tip type.')
          .optional(),
        presets: z
          .array(
            z.object({
              value: z
                .number()
                .describe(
                  "Value of the preset tip choice that's displayed to customers in the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\nFor example, `5`, `10`, and `15` percent or `1`, `3`, and `5` USD.\n\nMin: `0`"
                )
                .min(0)
                .optional()
                .nullable(),
              default: z
                .boolean()
                .describe(
                  "Whether this tip choice value is the default preset that's highlighted automatically in the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\n\nDefault: `false`"
                )
                .optional()
                .nullable(),
            })
          )
          .min(1)
          .max(3)
          .optional(),
        allowCustomerTip: z
          .boolean()
          .describe(
            'Whether customers are allowed to tip during the\neCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).\n\nDefault: `true`'
          )
          .optional()
          .nullable(),
        allowBusinessTipAtPayment: z
          .boolean()
          .describe(
            'Whether the Wix users are given the option to add a tip during the\npayment collection flow in their dashboard.\n\nDefault: `true`'
          )
          .optional()
          .nullable(),
        allowCustomAmount: z
          .boolean()
          .describe(
            "Whether customers can enter a custom tip amount. If set to `false`, customers\ncan only select a tip value from the available `presets` and can't enter a\ncustom amount.\n\nDefault: `true`"
          )
          .optional()
          .nullable(),
        allowEditDistribution: z
          .boolean()
          .describe(
            "Whether Wix users are allowed to edit tip distributions. If set to\n`false`, Wix users can't edit distributions after they were created.\n\nDefault: `true`"
          )
          .optional()
          .nullable(),
        staffDistributionMethod: z
          .enum(['UNKNOWN_SPLIT_METHOD', 'EQUAL', 'PROPORTIONAL'])
          .describe(
            'How the tip is distributed among staff.\n\nSupported values:\n`UNKNOWN_SPLIT_METHOD`: There is no information about the staff distribution method.\n`EQUAL`: The tip is distributed equally among all staff.\n`PROPORTIONAL`: The tip is distributed proportionally among staff.'
          )
          .optional(),
        revision: z
          .string()
          .regex(/^-?\d+$/, 'Must be a valid Int64 string')
          .describe(
            'Revision number, which increments by 1 each time `tipSettings` object is\nupdated. To prevent conflicting changes, the current revision must be passed\nwhen updating `tipSettings`. Ignored when creating a `tipSettings` object.'
          )
          .optional()
          .nullable(),
        _createdDate: z
          .date()
          .describe(
            'Date and time the tip settings were created in\n`YYYY-MM-DDThh:mm:ss.sssZ` format.'
          )
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe(
            'Date and time the tip settings were last updated in\n`YYYY-MM-DDThh:mm:ss.sssZ` format.'
          )
          .optional()
          .nullable(),
        default: z
          .boolean()
          .describe(
            "Whether these are the default tip settings.\n\nWix Tips automatically creates the default settings during\nthe app's installation. You can't delete these default settings\nbut you can update them. Wix Tips uses the default settings\nto calculate tips, unless you specify other settings."
          )
          .optional()
          .nullable(),
        appId: z
          .string()
          .describe(
            'ID of the app that has created the settings. See the list of app IDs for\nWix business solutions ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/apps-created-by-wix) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/apps-created-by-wix)).'
          )
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        extendedFields: z
          .object({
            namespaces: z
              .record(z.string(), z.record(z.string(), z.any()))
              .describe(
                'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
              )
              .optional(),
          })
          .describe(
            'Custom field data for the `tipSettings` object. Extended fields must be\nconfigured in the app dashboard before they can be accessed with API calls.'
          )
          .optional(),
      }),
      z.xor([
        z.object({
          locationId: z.never().optional(),
          paymentTerminalId: z.never().optional(),
          userId: z.never().optional(),
        }),
        z.object({
          paymentTerminalId: z.never().optional(),
          userId: z.never().optional(),
          locationId: z
            .string()
            .describe(
              'ID of the location ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/location-object))\nfor which the tip settings apply.'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            ),
        }),
        z.object({
          locationId: z.never().optional(),
          userId: z.never().optional(),
          paymentTerminalId: z
            .string()
            .describe(
              "ID of the payment terminal for which the tip settings apply. Wix Tips doesn't\nvalidate the ID you provide.\n\nMax: 30 characters"
            )
            .max(30),
        }),
        z.object({
          locationId: z.never().optional(),
          paymentTerminalId: z.never().optional(),
          userId: z
            .string()
            .describe(
              'ID of the Wix user for whom the tip settings apply. For example, the site owner or a\n[site collaborator](https://support.wix.com/en/article/inviting-people-to-contribute-to-your-site).'
            )
            .regex(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
              'Must be a valid GUID'
            ),
        }),
      ])
    )
    .describe('Created default tip settings.')
    .optional(),
});
export const DeleteTipSettingsRequest = z.object({
  tipSettingsId: z
    .string()
    .describe('ID of the `tipSettings` object to delete.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const DeleteTipSettingsResponse = z.object({});
